var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctk-input-address-predictions-empty tw-absolute tw-left-0 tw-bg-white tw-overflow-auto tw-rounded tw-text-center tw-py-2 tw-px-0 tw-w-full",class:{
    '--has-slot': !!_vm.$slots.default
  }},[_vm._t("no-result",function(){return [_c('div',{domProps:{"textContent":_vm._s(_vm.$t('app.values.no_result'))}})]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }